import React from "react";
import { FaInstagram, FaTiktok, FaFacebook, FaYoutube } from "react-icons/fa";

export default function Footer() {
  return (
    <footer>
      <div className="social-links">
        <a
          href="https://www.instagram.com/tapsi.wr/"
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon"
        >
          <FaInstagram size={28} />
        </a>
        <a
          href="https://www.tiktok.com/@tapsi.wr?is_from_webapp=1&sender_device=pc"
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon"
        >
          <FaTiktok size={28} />
        </a>
        <a
          href="https://www.facebook.com/groups/2071430503389722/"
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon"
        >
          <FaFacebook size={28} />
        </a>
        <a
          href="https://www.youtube.com/@%CE%A4%CE%91%CE%A8%CE%99/videos"
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon"
        >
          <FaYoutube size={28} />
        </a>
      </div>

      <p>&copy; {new Date().getFullYear()} Tapsi Radio. All rights reserved.</p>
    </footer>
  );
}